import type { ComponentProps, ElementType } from 'react';

import { cn } from '../lib/cn';

/** Superfície elevada do design system (DS-05): raio de card, borda e sombra vêm dos tokens. */
export function Card({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="card"
      className={cn(
        'flex flex-col gap-4 rounded-card border border-border bg-card p-5 text-card-foreground shadow-raised',
        className,
      )}
      {...props}
    />
  );
}

export function CardHeader({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div data-slot="card-header" className={cn('flex flex-col gap-1', className)} {...props} />
  );
}

export type CardTitleProps = ComponentProps<'h3'> & {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

/** O nível do título é escolha de quem usa (hierarquia da página), não do visual. */
export function CardTitle({ as = 'h3', className, ...props }: CardTitleProps) {
  const Comp: ElementType = as;
  return (
    <Comp
      data-slot="card-title"
      className={cn('text-title font-semibold text-heading', className)}
      {...props}
    />
  );
}

export function CardDescription({ className, ...props }: ComponentProps<'p'>) {
  return (
    <p
      data-slot="card-description"
      className={cn('text-body-sm text-muted-foreground', className)}
      {...props}
    />
  );
}

export function CardContent({ className, ...props }: ComponentProps<'div'>) {
  return <div data-slot="card-content" className={cn('text-body', className)} {...props} />;
}

export function CardFooter({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-footer"
      className={cn('flex items-center gap-2 border-t border-border pt-4', className)}
      {...props}
    />
  );
}
